import React from "react";
import { bool } from "prop-types";
import { routerActions } from "connected-react-router";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import Button from "pages/_components/Button";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import Options from "pages/accounts/_components/Options";
import AccountAction from "pages/accounts/_components/AccountAction";
import { TransactionCard, TransactionSign } from "pages/_components/TransactionCard";
import { TransactionHeader } from "./components/TransactionHeaderCheckbook";
import CheckbookSummary from "./components/CheckbookSummary";
import { useCheckbookTransaction } from "./hooks/useCheckbookTransaction";

const NewCheckbookSuccessPage = ({ isDesktop }) => {
    const { isLoading, transaction, dispatch, id, isBackoffice } = useCheckbookTransaction();
    const { componentRef, handlePrint, handlePrintMobile, mobileRef, handleShareMobile } = useReactPrint(
        "activities.request.checkbook.send",
        id,
        "/checks/successTransaction/",
    );

    const renderMenuOption = () => (
        <>
            {isDesktop ? (
                <div className="toolbar-item download" key="exportList">
                    <Button
                        className="btn btn-outline"
                        image="images/figma/icon/download.svg"
                        label="global.download"
                        onClick={isDesktop ? handlePrint : handlePrintMobile}
                        block={false}
                    />
                </div>
            ) : (
                <div className="toolbar-item commands-mobile" key="exportList">
                    <Button
                        className="btn"
                        image="images/figma/icon/download.svg"
                        onClick={isDesktop ? handlePrint : handlePrintMobile}
                        block={false}
                    />
                    <Button
                        className="btn btn-outline"
                        image="images/figma/icon/share.svg"
                        label="global.share"
                        onClick={() => {
                            handleShareMobile();
                        }}
                    />
                </div>
            )}
        </>
    );
    return (
        <>
            <Notification scopeToShow="/checks/successTransaction/" />
            {!isBackoffice && (
                <CustomProductHead
                    titleId="activities.request.checkbook.send"
                    exportList="global.download"
                    renderMenuOption={renderMenuOption}>
                    <div className="toolbar-item view-title">
                        <ViewTitle id="activities.request.checkbook.send" />
                    </div>
                </CustomProductHead>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader
                                subTitle={`forms.transaction.ticket.status.${transaction.idTransactionStatus}`}
                            />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div
                                        className="ticket__header"
                                        style={{ marginBottom: isDesktop ? "-20px" : "0" }}
                                    />
                                    <CheckbookSummary
                                        title="activities.request.checkbook.send"
                                        style={{ gridTemplateColumns: "repeat(1, 1fr)" }}
                                    />
                                    <div className="ticket__body">
                                        <TransactionSign creationTime isSmall isDesktop={isDesktop} showMoreData />
                                    </div>
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={4}>
                                <CustomButton
                                    func={() => dispatch(routerActions.push("/desktop"))}
                                    text="forms.transaction.ticket.actions.backToHome"
                                    textType="I18N"
                                    className="btn btn-primary"
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            </MainContainer>
            {!isDesktop && (
                <Options>
                    <AccountAction
                        isDesktop={isDesktop}
                        labelKey="global.download"
                        handleClick={isDesktop ? handlePrint : handlePrintMobile}
                    />
                </Options>
            )}
        </>
    );
};

NewCheckbookSuccessPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default NewCheckbookSuccessPage;
